import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  errorFound: {
    id: 'actorErrorFound',
    defaultMessage: 'Error found',
  },
  errorsFound: {
    id: 'errorsFound',
    defaultMessage: '{count} errors found',
  },
  formNoSections: {
    id: 'formNoSections',
    defaultMessage: 'There are no sections yet.',
  },
});

export default { ...globalIntl, ...m };
